import React from 'react';

function Welcome(props) {
  return <h1>{props.greeting}, {props.name}</h1>;
}

export default Welcome;
